const linkToCreate = {
	uk: `${process.env.REACT_APP_WEB_BASE_URL}/ua/create_ad`,
	ru: `${process.env.REACT_APP_WEB_BASE_URL}/create_ad`,
};

const mainLink = process.env.REACT_APP_WEB_BASE_URL;

// id приходят из АПИ, пока в документации по апи не описаны, возможны изменения, дополнения
const pageIdForSeoLinksBlock = {
	home: 1,
	mainCategory: 3,
	categoryLastLevel: 2,
	outputBordAD: 4,
	workCategoryLastLevel: 5,
	workMainCategory: 6,
	workOutputBordAD: 7,
};

const Constants = {
	linkToCreate,
	mainLink,
	pageIdForSeoLinksBlock,
};

export default Constants;
